import { pdsTv } from '@purinanbm/pds-ui';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { CMS_THEME } from '../../common/enums';
import OfferCardBody from './OfferCardBody';

interface Props {
  drupalId?: string;
  image: IGatsbyImageData;
  link: string;
  title: string;
  sku: string;
  cmsTheme?: CMS_THEME;
  brand?: string;
  onClick?: () => void;
}

const card = pdsTv({
  base: 'pds-flex pds-h-full pds-flex-col pds-border-none pds-bg-surface pds-text-surface-text',
  variants: {
    theme: {
      light: '',
      dark: 'pds-bg-surface-text pds-text-surface',
      neutral: 'pds-bg-surface-layer',
    },
  },
});

const OfferCard: React.FC<Props> = function ({
  title,
  link,
  image,
  sku,
  brand,
  drupalId,
  cmsTheme = CMS_THEME.LIGHT,
  onClick = () => {},
}: Props) {
  return (
    <div data-id={drupalId} className={card({ theme: cmsTheme })}>
      <OfferCardBody
        image={image}
        link={link}
        title={title}
        sku={sku}
        brand={brand}
        onClick={onClick}
        cmsTheme={cmsTheme}
      />
    </div>
  );
};
export default OfferCard;
